import { useTheme } from '@emotion/react';
import ChevronRightOutlined from '@mui/icons-material/ChevronRightOutlined';
import { FC } from 'react';
import { LinkProps } from 'react-router-dom';
import { StyledDashboardButton } from './DashboardButton.styles';

const DashboardButton: FC<LinkProps> = ({ to, children, ...props }) => {
  const theme = useTheme();
  return (
    <StyledDashboardButton to={to} {...props}>
      {children}
      <ChevronRightOutlined htmlColor={theme.colors.blue} />
    </StyledDashboardButton>
  );
};

export default DashboardButton;
